export default __webpack_public_path__ + "static/media/Robin Young.88a00d43.jpg";